import type { PartialTranslations } from "../types";

export const es: PartialTranslations = {
	auth: {
		login: {
			headline: "Cuenta tu historia.",
			subheadline: "Inicia sesión para continuar donde lo dejaste.",
			emailPlaceholder: "tu@correo.com",
			passwordPlaceholder: "contraseña",
			submitIdle: "Iniciar sesión",
			submitLoading: "Iniciando sesión...",
			noAccount: "¿No tienes cuenta?",
			beginHere: "Empieza aquí.",
			errorInvalid: "Correo o contraseña incorrectos.",
			errorGeneric: "Algo salió mal. Por favor intenta de nuevo.",
		},
		register: {
			headline: "Empieza aquí.",
			subheadline: "Toda historia tiene un comienzo.",
			namePlaceholder: "tu nombre",
			emailPlaceholder: "tu@correo.com",
			passwordPlaceholder: "elige una contraseña",
			submitIdle: "Crear cuenta",
			submitLoading: "Creando cuenta...",
			alreadyHaveAccount: "¿Ya tienes cuenta?",
			signIn: "Inicia sesión.",
			errorConflict: "Ya existe una cuenta con ese correo.",
			errorGeneric: "Algo salió mal. Por favor intenta de nuevo.",
		},
	},
	stories: {
		list: {
			headline: "Tus historias.",
			beginNew: "Comenzar una nueva historia.",
			loading: "Cargando tus historias...",
			errorLoad: "No se pudieron cargar las historias. Intenta refrescar.",
			empty: "Aún no has escrito nada.",
			noTag: 'Sin historias con la etiqueta "{{tag}}".',
			filterBy: "Filtrar por etiqueta",
			clearFilter: "Quitar filtro",
			showAll: "Ver todas las historias",
			storiesCount_one: "{{count}} historia",
			storiesCount_other: "{{count}} historias",
			filteredCount: "Mostrando {{filtered}} de {{total}}",
			searchPlaceholder: "Busca tus historias…",
			sortNewest: "Más recientes primero",
			sortOldest: "Más antiguas primero",
			pageOf: "Página {{page}} de {{pages}}",
			noResults: "No hay historias que coincidan con tu búsqueda.",
		},
		new: {
			back: "← Volver",
			titlePlaceholder: "Dale un nombre, o déjalo en blanco.",
			voicePrompt:
				"Cuenta tu historia como si le hablaras a un amigo. Así como te salga, está bien.",
			switchToText: "Escribir en su lugar →",
			writePrompt:
				"Escríbelo como se lo contarías a un amigo. Así como te salga, está bien.",
			switchToVoice: "← Usar voz en su lugar",
			modeText: "Escribir",
			modeVoice: "Hablar",
			submitIdle: "Enviar.",
			submitLoading: "Enviando...",
			errorGeneric: "Algo salió mal. Por favor intenta de nuevo.",
		},
		card: {
			untitled: "Historia sin título",
			status: {
				processing: "Procesando...",
				awaiting_response: "Esperando tu respuesta",
				done: "Revisado",
				failed: "Fallido",
			},
		},
		detail: {
			loading: "Cargando...",
			notFound: "Historia no encontrada.",
			processing: {
				reading: "Escuchando…",
				transcribing: "Encontrándole sentido…",
			},
			failed: {
				heading: "Algo salió mal",
				explanation:
					"Algo salió mal al procesar tu historia. Puedes intentarlo de nuevo — tu grabación original está a salvo.",
				tryAgain: "Intentar de nuevo",
				retrying: "Reintentando…",
			},
			coaching: {
				akinNotes: "Notas de Akin",
				showNote: "Mostrar {{label}}",
				questionStep: "Pregunta {{step}} de {{total}}",
				takeYourTime: "Tómate tu tiempo...",
				switchToVoice: "← Usar voz en su lugar",
				switchToText: "Escribir en su lugar →",
				back: "← Atrás",
				next: "Siguiente",
				skip: "Saltar",
				doneSendAnswers: "Listo — enviar respuestas",
				reviewAndSubmit: "Revisar y enviar",
				uploading: "Subiendo…",
				imDone: "Ya terminé con esta historia.",
				imDoneConfirm:
					"Esto marcará tu historia como terminada. ¿Estás seguro?",
				imDoneYes: "Sí, marcar como terminado",
				imDoneCancel: "Seguir",
				transcribing_one: "Transcribiendo {{count}} respuesta…",
				transcribing_other: "Transcribiendo {{count}} respuestas…",
				transcriptionFailed: "Transcripción fallida — escribe tu respuesta",
				transcriptionFailedNote:
					"Transcripción fallida — escribe tu respuesta o déjala en blanco.",
				leaveBlank: "Dejar en blanco para omitir",
				submit: "Enviar",
				submitting: "Enviando…",
				voiceUploadFailed:
					"Algunas respuestas de voz no pudieron cargarse. Escríbelas abajo.",
				retryVoiceUpload: "Intentar subir de nuevo",
			},
			transcriptionPreview: {
				heading: "Esto es lo que escuchamos",
				noTranscription: "No hay transcripción disponible.",
				editTranscription: "Editar transcripción",
				cancel: "Cancelar",
				save: "Guardar",
				saving: "Guardando…",
				looksGood: "Se ve bien — revisarlo",
				starting: "Iniciando…",
			},
			storyUpdate: {
				roundComplete: "Ronda {{number}} completa",
				akinNotes: "Notas de Akin",
				titlePlaceholder: "Dale un nombre, o déjalo en blanco.",
				storyPlaceholder: "Tu historia aparecerá aquí...",
				saveChanges: "Guardar cambios",
				saving: "Guardando…",
				keepGoing: "Seguir",
				imDone: "Ya terminé con esta historia.",
			},
			done: {
				akinNotes: "Notas de Akin",
				backToStories: "← Tus historias",
				yourRecording: "Tu grabación",
				copyText: "Copiar texto",
				copied: "Copiado.",
				answerQuestionsAgain: "Responder preguntas de nuevo",
				starting: "Iniciando…",
				beginNew: "Comenzar una nueva historia",
				edit: "Editar",
				cancel: "Cancelar",
				saveChanges: "Guardar cambios",
				saving: "Guardando…",
				recordStory: "Graba tu historia",
				deleteStory: "Eliminar historia",
			},
			deleteConfirm: {
				heading: "¿Eliminar esta historia?",
				body: "Esto no se puede deshacer. La historia y todo su historial serán eliminados permanentemente.",
				confirm: "Sí, eliminar",
				cancel: "Cancelar",
				deleting: "Eliminando…",
			},
			rerecord: {
				eyebrow: "Una cosa más",
				heading: "Cuéntala de nuevo, ahora que recuerdas más.",
				body: "Ya hiciste el trabajo difícil de recordar. Esta es tu oportunidad de grabar la historia como realmente sucedió — con tu propia voz y todos los detalles que has descubierto.",
				modeReadTitle: "Léela en voz alta",
				modeReadDesc:
					"Te mostraremos la historia refinada para leer a tu propio ritmo. Ideal si quieres que suene pulida.",
				modeRetellTitle: "Cuéntala con tus propias palabras",
				modeRetellDesc:
					"Sin guión. Solo tú y lo que recuerdas ahora. Ideal si quieres que suene como tú.",
				startRecording: "Comenzar grabación",
				saveRecording: "Guardar esta grabación",
				saving: "Guardando…",
				skipNow: "Ahora no — quizás después",
				teleprompterLabel: "Tu historia",
				error: "Algo salió mal. Por favor intenta de nuevo.",
				uploadFailed: "Tu grabación no pudo guardarse.",
				retryUpload: "Intentar subir de nuevo",
			},
		},
	},
	profile: {
		headline: "Tu perfil.",
		back: "← Volver",
		email: "Correo",
		name: "Nombre",
		edit: "Editar",
		save: "Guardar",
		saving: "Guardando…",
		cancel: "Cancelar",
		changePassword: "Cambiar contraseña",
		currentPassword: "Contraseña actual",
		newPassword: "Nueva contraseña",
		passwordUpdated: "Contraseña actualizada.",
		signOut: "Cerrar sesión",
		memberSince: "Miembro desde {{date}}",
		storiesCount_one: "{{count}} historia escrita",
		storiesCount_other: "{{count}} historias escritas",
		errorPasswordWrong: "La contraseña actual es incorrecta.",
		errorGeneric: "Algo salió mal. Por favor intenta de nuevo.",
	},
	audio: {
		startRecording: "Comenzar grabación",
		stopRecording: "Detener grabación",
		tapToRecord: "Toca para grabar",
		tapToStop: "Toca para detener",
		reRecord: "Volver a grabar",
		ready: "Listo ✓",
		micDenied:
			"Acceso al micrófono denegado. Por favor permítelo en la configuración de tu navegador.",
	},
	tags: {
		ariaLabel: "Etiquetas de historia",
		removeTag: "Eliminar etiqueta {{tag}}",
		placeholder: "nombre de etiqueta…",
		addTag: "+ etiqueta",
	},
	onboarding: {
		intro: {
			skip: "Saltar",
			alreadyHaveAccount: "¿Ya tienes cuenta?",
			logIn: "Inicia sesión.",
			screens: [
				{
					headline: "Cada vida es una biblioteca.",
					body: "No la versión curada. La real — los olores, los errores, las comidas, los momentos que nadie más recuerda.",
					cta: "Siguiente →",
				},
				{
					headline: "Akin te ayuda a contarla.",
					body: "Hablas, escribes o simplemente recuerdas. Akin escucha, hace las preguntas correctas y da forma a lo que dices en algo que vale la pena guardar.",
					cta: "Siguiente →",
				},
				{
					headline: "Tu primera historia empieza ahora.",
					body: "No tiene que ser perfecta. Solo tiene que ser verdad.",
					cta: "Comenzar →",
				},
			],
		},
		prompts: {
			eyebrow: "Tu primera historia",
			headline: "¿Qué quieres recordar?",
			subtext: "Elige una que se sienta bien.",
			note: "Puedes explorar más prompts en cualquier momento. Por ahora, elige uno que se sienta bien.",
			cta: "Comenzar a grabar →",
		},
		celebration: {
			eyebrow: "Tu primera historia",
			headline: "Está guardada.",
			body: "Tu primera historia está guardada. Continúa cuando quieras.",
			cta: "Ver tu archivo →",
		},
	},
	home: {
		welcome: "Hola, {{name}}.",
		beginNewStory: "Comenzar nueva historia",
		loading: "Cargando…",
		error: "Algo salió mal. Por favor recarga la página.",
		todaysPrompt: "Prompt de hoy",
		recentStories: "Historias recientes",
		untitled: "Sin título",
		stillTellingMany: "{{count}} historias que sigues contando",
		continue: "Continuar",
		record: "Grabar",
		write: "Escribir",
		anotherPrompt: "Otro prompt",
		startWithoutPrompt: "Comenzar sin un prompt",
		storiesEmpty: "Tus historias vivirán aquí.",
		viewAll: "Ver todas las historias",
		totalStories_one: "{{count}} historia →",
		totalStories_other: "{{count}} historias →",
		encouragement: {
			line0: "Estás construyendo algo real.",
			line1: "Tres esta semana. Sigue adelante.",
			line2: "Estas historias son tuyas para siempre.",
			line3: "Una vida que vale la pena recordar, historia a historia.",
			line4: "Cada palabra aquí importa.",
			withCount: "{{count}} historias esta semana. {{line}}",
		},
	},
};
